module.exports = __webpack_public_path__ + "static/9-woman-running-e36b1e7d350d72002faa09f88b114cfa.png";